module.exports = __webpack_public_path__ + "img/im-replies.7b44b708.svg";